// src/theme/constants.ts
export const HEADER_HEIGHT = {
    desktop: '160px',
    tablet: '90px',
};

export const FOOTER_HEIGHT = 'auto';

